module.exports = __webpack_public_path__ + "img/s_9.c67fce09.png";